import * as React from "react";
const SvgInputTypeNumberArrow = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.7998 13.8H13.1998L8.9998 8.40002L4.7998 13.8Z", fill: "#060809" }));
export default SvgInputTypeNumberArrow;
